/**
 * throws an error if the supplied value is `null` or `undefined`
 *
 * @param value a nullable, or optional, value, in promise
 * @param errorMessage an optional error message to use instead of the defaults
 * @throws if {@link value} is null or undefined
 * @example
 * const defaultNullErrorMessage = 'Value is null'
 * const defaultUndefinedErrorMessage = 'Value is undefined'
 */
export function required<T>(
  value: T | null | undefined,
  errorMessage?: string
) {
  const err = (message: string) => new Error(errorMessage ?? message)
  if (value === null) throw err('Value is null')
  else if (value === undefined) throw err('Value is undefined')
  return value
}

/**
 * a version of {@link required} which awaits the supplied promise before passing
 * it along to required
 *
 * @param promise a promise to await before resolving
 * @param errorMessage an optional error message
 * @see {@link required}
 */
export async function requiredPromise<T>(
  promise: Promise<T | null | undefined> | null | undefined,
  errorMessage?: string
) {
  const awaited = await promise
  return required(awaited, errorMessage)
}
